import { WorldpayCustomisationBorder } from '../../models/worldpay/worldpay-customisation-border.interface';

export const mockWorldpayCustomisationBorder: WorldpayCustomisationBorder = {
  color: '#00000',
  radius: '2px',
  style: 'dashed',
  width: '2px',
};
